import React from 'react'
import { Box } from '../Box/Box'
import colors from '../../_constants/colors'
import { S_Progress, S_ProgressBar } from './Progress.styles'
import PropTypes from 'prop-types'
import { RenderIf } from '../helpers/RenderIf/RenderIf'
import { Text } from '../../_components/Typography/Components/Text/Text'

export const Progress = ({ width, textStatus, fillColor, progress }) => {
  return (
    <S_Progress>
      <S_ProgressBar width={width}>
        <Box
          borderRadius={'10px'}
          boxBackgroundColor={colors.INNER_GREY_BOX}
          boxHeight={'15px'}
          boxWidth={width}
          className={'progress-bg'}
        />
        <Box
          borderRadius={'10px'}
          boxBackgroundColor={fillColor}
          boxHeight={'15px'}
          boxWidth={progress || '0%'}
          className={'progress-line'}
        />
      </S_ProgressBar>
      <RenderIf condition={textStatus}>
        <Text className="italic" ml={'5px'} textColor={fillColor}>
          {textStatus}
        </Text>
      </RenderIf>
    </S_Progress>
  )
}

Progress.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  textStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  fillColor: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  progress: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
}

Progress.defaultProps = {
  width: 'auto',
  textStatus: false,
  fillColor: colors.TEXT_LIGHT,
  progress: '0%',
}
